export const ROUTE_TYPES = {
  shareableRoutes: 'shareableRoutes',
  protectedRoutes: 'protectedRoutes',
  publicRoutes: 'publicRoutes',
} as const;
